import localStorage from './localStorage'

// The page someone tried to open before signing in (for example "Add your first recipe"
// from an email), so signing in takes them there instead of to their profile
const KEY = 'MORSEL_RETURN_TO'

// Only addresses inside Morsel, never another site
const isAppPath = (path) => typeof path === 'string' && /^\/(?!\/)/.test(path) && path !== '/'

export const rememberReturnPath = (path) => {
  try {
    if (isAppPath(path)) localStorage.setItem(KEY, path)
  } catch (e) {
    // private browsing: they land on their profile instead
  }
}

// Read once: the next sign-in after that goes to the profile as usual
export const takeReturnPath = () => {
  try {
    const path = localStorage.getItem(KEY)
    localStorage.removeItem(KEY)
    return isAppPath(path) ? path : ''
  } catch (e) {
    return ''
  }
}
